import { Collectible, POWER_UPS, POWER_DOWNS } from "./Collectible";
import type { CollectKind } from "./Collectible";
import { Obstacle, type ObstacleKind } from "./Obstacle";

type Pattern = {
  events: { at: number; kind: ObstacleKind; gapWidth?: number }[];
  clearAfter: number;
};

const PATTERNS_EASY: Pattern[] = [
  { events: [{ at: 0, kind: "brick_block" }], clearAfter: 400 },
  { events: [{ at: 0, kind: "kebab_spikes" }], clearAfter: 420 },
  { events: [{ at: 0, kind: "oil_slick" }], clearAfter: 400 },
  { events: [{ at: 0, kind: "mayo_puddle" }], clearAfter: 400 },
  { events: [{ at: 0, kind: "policeman" }], clearAfter: 440 },
  { events: [{ at: 0, kind: "giant_dick" }], clearAfter: 460 },
  { events: [{ at: 0, kind: "gap", gapWidth: 120 }], clearAfter: 480 },
  { events: [{ at: 0, kind: "pastor" }], clearAfter: 420 },
  { events: [{ at: 0, kind: "horizontal_dick" }], clearAfter: 420 },
  { events: [{ at: 0, kind: "shit_pile" }], clearAfter: 400 },
  {
    events: [
      { at: 0, kind: "brick_block" },
      { at: 56, kind: "brick_block" },
    ],
    clearAfter: 440,
  },
  // weighted extras
  { events: [{ at: 0, kind: "policeman" }], clearAfter: 420 },
  { events: [{ at: 0, kind: "giant_dick" }], clearAfter: 440 },
];

const PATTERNS_MID: Pattern[] = [
  { events: [{ at: 0, kind: "grease_drum" }], clearAfter: 440 },
  { events: [{ at: 0, kind: "soda_can" }], clearAfter: 420 },
  { events: [{ at: 0, kind: "pipe" }], clearAfter: 460 },
  { events: [{ at: 0, kind: "shit_pile" }], clearAfter: 420 },
  { events: [{ at: 0, kind: "horizontal_dick" }], clearAfter: 440 },
  { events: [{ at: 0, kind: "deep_fryer" }], clearAfter: 450 },
  { events: [{ at: 0, kind: "gap", gapWidth: 140 }], clearAfter: 500 },
  { events: [{ at: 0, kind: "policeman" }], clearAfter: 440 },
  { events: [{ at: 0, kind: "policeman" }], clearAfter: 460 },
  { events: [{ at: 0, kind: "giant_dick" }], clearAfter: 460 },
  { events: [{ at: 0, kind: "giant_dick" }], clearAfter: 480 },
  { events: [{ at: 0, kind: "pastor" }], clearAfter: 440 },
  {
    events: [
      { at: 0, kind: "kebab_spikes" },
      { at: 200, kind: "pastor" },
    ],
    clearAfter: 420,
  },
  { events: [{ at: 0, kind: "scooter" }], clearAfter: 500 },
  {
    events: [
      { at: 0, kind: "brick_block" },
      { at: 56, kind: "brick_block" },
      { at: 112, kind: "brick_block" },
    ],
    clearAfter: 460,
  },
  {
    events: [
      { at: 0, kind: "oil_slick" },
      { at: 200, kind: "policeman" },
    ],
    clearAfter: 440,
  },
  {
    events: [
      { at: 0, kind: "pipe" },
      { at: 220, kind: "giant_dick" },
    ],
    clearAfter: 460,
  },
  {
    events: [
      { at: 0, kind: "giant_dick" },
      { at: 180, kind: "pastor" },
    ],
    clearAfter: 480,
  },
  {
    events: [
      { at: 0, kind: "policeman" },
      { at: 240, kind: "horizontal_dick" },
    ],
    clearAfter: 460,
  },
];

const PATTERNS_HARD: Pattern[] = [
  { events: [{ at: 0, kind: "health_inspector" }], clearAfter: 460 },
  { events: [{ at: 0, kind: "giant_dick" }], clearAfter: 460 },
  { events: [{ at: 0, kind: "giant_dick" }], clearAfter: 480 },
  { events: [{ at: 0, kind: "giant_dick" }], clearAfter: 500 },
  { events: [{ at: 0, kind: "policeman" }], clearAfter: 440 },
  { events: [{ at: 0, kind: "policeman" }], clearAfter: 460 },
  { events: [{ at: 0, kind: "policeman" }], clearAfter: 480 },
  { events: [{ at: 0, kind: "pastor" }], clearAfter: 440 },
  {
    events: [
      { at: 0, kind: "gap", gapWidth: 150 },
      { at: 280, kind: "pastor" },
    ],
    clearAfter: 460,
  },
  {
    events: [
      { at: 0, kind: "kebab_spikes" },
      { at: 180, kind: "grease_drum" },
    ],
    clearAfter: 460,
  },
  {
    events: [
      { at: 0, kind: "scooter" },
      { at: 260, kind: "mayo_puddle" },
    ],
    clearAfter: 480,
  },
  {
    events: [
      { at: 0, kind: "pastor" },
      { at: 200, kind: "pipe" },
    ],
    clearAfter: 500,
  },
  {
    events: [
      { at: 0, kind: "giant_dick" },
      { at: 200, kind: "policeman" },
    ],
    clearAfter: 500,
  },
  {
    events: [
      { at: 0, kind: "policeman" },
      { at: 180, kind: "giant_dick" },
    ],
    clearAfter: 500,
  },
  {
    events: [
      { at: 0, kind: "giant_dick" },
      { at: 160, kind: "giant_dick" },
    ],
    clearAfter: 520,
  },
  {
    events: [
      { at: 0, kind: "policeman" },
      { at: 200, kind: "policeman" },
    ],
    clearAfter: 520,
  },
  {
    events: [
      { at: 0, kind: "brick_block" },
      { at: 56, kind: "horizontal_dick" },
      { at: 200, kind: "gap", gapWidth: 140 },
    ],
    clearAfter: 500,
  },
  { events: [{ at: 0, kind: "gap", gapWidth: 160 }], clearAfter: 520 },
  {
    events: [
      { at: 0, kind: "pastor" },
      { at: 160, kind: "health_inspector" },
    ],
    clearAfter: 480,
  },
  {
    events: [
      { at: 0, kind: "giant_dick" },
      { at: 220, kind: "pastor" },
      { at: 400, kind: "policeman" },
    ],
    clearAfter: 540,
  },
];

function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]!;
}

export class Spawner {
  private cursor = 900;
  private collectAt = 700;
  private introDone = false;
  /** Forbidden world-X ranges for coins (gaps + fat obstacles). */
  private readonly noCoinZones: { left: number; right: number }[] = [];
  readonly obstacles: Obstacle[] = [];
  readonly collectibles: Collectible[] = [];
  private readonly poolObs: Obstacle[] = [];
  private readonly poolCol: Collectible[] = [];

  constructor(poolSize = 48) {
    for (let i = 0; i < poolSize; i++) {
      this.poolObs.push(new Obstacle());
      this.poolCol.push(new Collectible());
    }
  }

  reset(): void {
    for (const o of this.obstacles) o.active = false;
    for (const c of this.collectibles) c.active = false;
    this.obstacles.length = 0;
    this.collectibles.length = 0;
    this.noCoinZones.length = 0;
    this.cursor = 900;
    this.collectAt = 700;
    this.introDone = false;
  }

  private takeObs(): Obstacle {
    const o = this.poolObs.find((p) => !p.active) ?? new Obstacle();
    if (!this.poolObs.includes(o)) this.poolObs.push(o);
    return o;
  }

  private takeCol(): Collectible {
    const c = this.poolCol.find((p) => !p.active) ?? new Collectible();
    if (!this.poolCol.includes(c)) this.poolCol.push(c);
    return c;
  }

  private table(difficulty: number): Pattern[] {
    if (difficulty < 0.28) return PATTERNS_EASY;
    if (difficulty < 0.62) return [...PATTERNS_EASY, ...PATTERNS_MID];
    return [...PATTERNS_MID, ...PATTERNS_HARD];
  }

  private banCoin(left: number, right: number): void {
    this.noCoinZones.push({ left, right });
    if (this.noCoinZones.length > 80) this.noCoinZones.splice(0, 20);
  }

  private coinSafe(x: number, margin = 36): boolean {
    for (const z of this.noCoinZones) {
      if (x >= z.left - margin && x <= z.right + margin) return false;
    }
    for (const o of this.obstacles) {
      if (!o.active || o.kind !== "gap") continue;
      if (x >= o.x - margin && x <= o.x + o.gapWidth + margin) return false;
    }
    return true;
  }

  private spawnCoin(
    x: number,
    y: number,
    kind: "coin" | "drumstick" = "coin"
  ): void {
    if (!this.coinSafe(x)) return;
    const c = this.takeCol();
    c.spawn(kind, x, y);
    this.collectibles.push(c);
  }

  private spawnCoinArc(
    startX: number,
    groundY: number,
    count: number,
    peak = 110
  ): void {
    for (let i = 0; i < count; i++) {
      const t = count === 1 ? 0.5 : i / (count - 1);
      const x = startX + i * 36;
      if (!this.coinSafe(x)) continue;
      const y = groundY - 36 - Math.sin(t * Math.PI) * peak;
      this.spawnCoin(x, y, "coin");
    }
  }

  update(
    _dt: number,
    camX: number,
    groundY: number,
    scrollSpeed: number,
    difficulty: number
  ): void {
    for (let i = this.obstacles.length - 1; i >= 0; i--) {
      const o = this.obstacles[i]!;
      o.update(_dt, groundY);
      if (!o.active || o.offscreen(camX)) {
        o.active = false;
        this.obstacles.splice(i, 1);
      }
    }
    for (let i = this.collectibles.length - 1; i >= 0; i--) {
      const c = this.collectibles[i]!;
      c.update(_dt);
      if (!c.active || c.offscreen(camX)) {
        c.active = false;
        this.collectibles.splice(i, 1);
      }
    }

    if (!this.introDone) {
      this.introDone = true;
      this.cursor = camX + 1400;
      this.collectAt = camX + 900;
      this.spawnCoinArc(camX + 980, groundY, 5, 70);
    }

    const lead = 1320;
    while (this.cursor < camX + lead) {
      const pattern = pick(this.table(difficulty));
      const start = this.cursor;
      let patternEnd = start;
      let spawnedGap: { x: number; w: number } | null = null;

      for (const ev of pattern.events) {
        const o = this.takeObs();
        const x = start + ev.at;
        let gapW = ev.gapWidth ?? 0;
        if (ev.kind === "gap") {
          const maxGap = Math.min(220, 120 + scrollSpeed * 0.28);
          gapW = Math.min(gapW || 150, maxGap);
          spawnedGap = { x, w: gapW };
          this.banCoin(x, x + gapW);
        } else {
          this.banCoin(x - 30, x + 30);
        }
        o.spawn(ev.kind, x, groundY, scrollSpeed, gapW);
        this.obstacles.push(o);
        patternEnd = Math.max(
          patternEnd,
          x + (ev.kind === "gap" ? gapW : Math.max(80, o.w))
        );
      }

      if (spawnedGap) {
        this.spawnCoinArc(spawnedGap.x - 140, groundY, 3, 70);
        this.spawnCoinArc(spawnedGap.x + spawnedGap.w + 50, groundY, 3, 80);
      } else if (Math.random() < 0.5) {
        this.spawnCoinArc(
          patternEnd + 40,
          groundY,
          3 + ((Math.random() * 2) | 0),
          90
        );
      }

      const clearScale = 1 - difficulty * 0.22;
      this.cursor =
        patternEnd + pattern.clearAfter * clearScale + Math.random() * 60;
    }

    while (this.collectAt < camX + lead) {
      if (this.coinSafe(this.collectAt, 40)) {
        const roll = Math.random();
        let kind: CollectKind;
        if (roll < 0.05) {
          // 5% power-up
          kind = pick(POWER_UPS);
        } else if (roll < 0.12 && difficulty > 0.4) {
          // 7% power-down at higher difficulty
          kind = pick(POWER_DOWNS);
        } else if (roll < 0.30) {
          kind = "drumstick";
        } else {
          kind = "coin";
        }
        const y =
          Math.random() < 0.4
            ? groundY - 42
            : groundY - 75 - Math.random() * 50;
        const c = this.takeCol();
        c.spawn(kind, this.collectAt, y);
        this.collectibles.push(c);
      }
      this.collectAt += 280 + Math.random() * 180;
    }
  }

  groundAt(feetX: number, baseGround: number, feetHalf = 10): number | null {
    for (const o of this.obstacles) {
      if (!o.active || o.kind !== "gap") continue;
      const left = o.x;
      const right = o.x + o.gapWidth;
      if (feetX + feetHalf > left && feetX - feetHalf < right) {
        const lip = 6;
        if (feetX > left + lip && feetX < right - lip) return null;
      }
    }
    return baseGround;
  }

  gapAt(worldX: number): Obstacle | null {
    for (const o of this.obstacles) {
      if (!o.active || o.kind !== "gap") continue;
      if (worldX >= o.x && worldX <= o.x + o.gapWidth) return o;
    }
    return null;
  }
}
